module Omni.ResortMap {
    ngModule.directive('floorSelect', (['$document', '$state',
        function ($document, $state) {
            return {
                restrict: 'C',
                link: function (scope, element, attrs) {
                    var floor;
                    element.on("change", function (e) {
                        floor = e.target.value;
                        $state.go("floor.detail", { floorId: floor });
                    });
                }
            };
        }]) as any);
}
